import { useQuery } from "react-query";
import axios from "axios";
import { BessPcsModulesResponse } from "./PcsModuleTypes";

// Endpoint do main-api (via gateway /main -> /api/bess). O header Email/Bearer
// é injetado automaticamente pelo AxiosInterceptor.
const pcsModulesUrl = (equipmentId: number) => `api/bess/${equipmentId}/pcs-modules`;

const fetchPcsModules = async (equipmentId: number): Promise<BessPcsModulesResponse> => {
    return await axios
        .get<BessPcsModulesResponse>(pcsModulesUrl(equipmentId), { timeout: 30000 })
        .then((res) => res.data);
};

export const useBessPcsModules = (equipmentId: number) => {
    return useQuery({
        queryKey: ["bess-pcs-modules", equipmentId],
        queryFn: () => fetchPcsModules(equipmentId),
        enabled: Boolean(equipmentId),
    });
};
